import { motion } from 'framer-motion';
import { useState } from 'react';

const Detail = ({ project }) => {

  const [open, setOpen] = useState(false);



  return (
    <motion.div
      className="relative w-full h-full items-center flex p-8 bg-gradient-to-br from-blackLight via-blackDark to-black"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      {/* Fondo con gradiente radial */}
      <motion.div
        className="absolute left-10 w-full h-full pointer-events-none"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.2 }}
      />
      {/* Contenido */}
      <motion.div
        className="relative text-white text-center z-10 space-y-8 bg-beige/90 p-8 rounded-lg "
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.4 }}
      >
        <h2 className="text-4xl font-bold text-persian">{project.name}</h2>
        <motion.button
        onClick={() => setOpen(!open)}
        whileHover={{ color: "#F0EFD6" }} // Solo cambio de color del texto
        whileTap={{ scale: 0.9 }}
        className="relative bg-transparent border border-persian text-persian font-bold py-3 px-16 flex justify-center items-center gap-4 overflow-hidden group"
        >
            <span className="z-10 ">Ver detalle</span>
            <span className="absolute inset-0 bg-persian transition-all duration-500 transform -translate-x-full group-hover:-translate-x-0"></span>

        </motion.button>
      </motion.div>
     {/* { open && ( 
      <motion.section className='text-white'>
        <p>{project.description}</p>
      </motion.section>)} */}
    </motion.div>
  );
};

export default Detail;